export default "__VITE_ASSET__CqhVoPUD__"